import { LDFlagValue } from 'launchdarkly-js-client-sdk';
import { LDFlags } from 'shared/consts';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const useFlag = <V extends LDFlagValue = boolean>(flag: LDFlags, defaultValue?: V): V | undefined => {
  const allFlags = useFlags();

  return allFlags[flag] ?? defaultValue;
};
